import { ActionTree, GetterTree, MutationTree } from "vuex";
import { StepsStoreTypes } from "@/types/StepsType";

const state: StepsStoreTypes = {
  flow: "MIGRATION",
  step: 1,
  deliveryChip: false,
  portability: false,
};

const getters: GetterTree<StepsStoreTypes, any> = {
  flow: (st) => st.flow,
  step: (st) => st.step,
  deliveryChip: (st) => st.deliveryChip,
  portability: (st) => st.portability,
};

const mutations: MutationTree<StepsStoreTypes> = {
  setFlow(st: StepsStoreTypes, flow) {
    st.flow = flow;
  },
  setStep(st: StepsStoreTypes, step) {
    st.step = step;
  },
  setDeliveryChip(st: StepsStoreTypes, deliveryChip) {
    st.deliveryChip = deliveryChip;
  },
  setPortability(st: StepsStoreTypes, portability) {
    st.portability = portability;
  },
};

const actions: ActionTree<StepsStoreTypes, any> = {
  setFlow({ commit }, flow) {
    commit("setFlow", flow);
  },
  setStep({ commit }, step) {
    commit("setStep", step);
  },
  setDeliveryChip({ commit }, deliveryChip) {
    commit("setDeliveryChip", deliveryChip);
  },
  setPortability({ commit }, portability) {
    commit("setPortability", portability);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
